// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__JPrU4","icon":"style_icon__c0T-T"};